import { rest as API } from './rest';

const addressBasePath = ({ customerUUID, ecosystemUUID }) =>
  `/v2/customers/${customerUUID}/ecosystems/${ecosystemUUID}/addresses`;
const publicAddressBasePath = ({ customerUUID, ecosystemUUID }) =>
  `/v2/customers/${customerUUID}/ecosystems/${ecosystemUUID}/publicAddresses`;

export const getAddressList = (params) =>
  API.get(addressBasePath(params), { params: params.query ?? '' }).then(({ data }) => data);

export const getAddressDetail = (params) =>
  API.get(`${addressBasePath(params)}/${params.uuid}`).then(({ data }) => data);

export const createAddress = (params) => API.post(addressBasePath(params), params.payload).then(({ data }) => data);

export const updateAddress = (params) =>
  API.put(`${addressBasePath(params)}/${params.uuid}`, params.payload).then(({ data }) => data);

export const deleteAddress = (params) =>
  API.delete(`${addressBasePath(params)}/${params.uuid}`).then(({ data }) => data);

export const createPublicAddress = (params) =>
  API.post(publicAddressBasePath(params), params.payload).then(({ data }) => data);
